export const config = {
    appname: 'burgerking',
    client_id: '1351788021633457', // App ID
    facebook_app_id: '1351788021633457', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'apibgk2',
    agency_id: '111421',
    bzbsUrlOldSupport: 'https://stg.buzzebees.com',
    bzbsUrl: 'https://apibgk2.buzzebees-uat.com',
    bzbsModuleUrl: 'https://burgerkingmodule.buzzebees-uat.com',
    bkDeliveryModuleUrl: 'https://deliverymodule9.buzzebees-uat.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule9.buzzebees-uat.com',
    webShoppingCartUrl: 'https://shoppingcartservice9.buzzebees-uat.com',
    bzbsBlobUrl: 'https://cdn.buzzebees-uat.com/th',
    miscUrl: 'https://misc.buzzebees-uat.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    minorPrivacyUrl: {
        th: 'https://www.minorfood.com/th/privacy/dsar',
        en: 'https://www.minorfood.com/en/privacy/dsar',
    },

    firebase: {
        apiKey: "AIzaSyDonqvBivoDvwP2owdgHosK5XMHiaKrleo",
        authDomain: "mfg-burger-king-uat.firebaseapp.com",
        projectId: "mfg-burger-king-uat",
        storageBucket: "mfg-burger-king-uat.appspot.com",
        messagingSenderId: "603255573485",
        appId: "1:603255573485:web:2afff9194dcb38e71cb5e4",
        measurementId: "G-GWNWZ75MTV"
    },
};
